import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LayoutDashboard, Package, LogOut, Anchor } from 'lucide-react';

export const Sidebar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <aside className="sidebar w-64 min-h-screen flex flex-col" data-testid="sidebar">
      {/* Logo */}
      <div className="p-6 border-b border-[#1E293B]">
        <div className="flex items-center gap-3">
          <Anchor className="w-8 h-8 text-white" />
          <div>
            <h1 className="font-heading text-xl font-bold text-white">Le Boating Club</h1>
            <p className="text-xs text-slate-400 uppercase tracking-wider">Kitchen Inventory</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-6">
        <NavLink
          to="/dashboard"
          className={({ isActive }) => 
            `sidebar-link ${isActive ? 'active' : ''}`
          }
          data-testid="nav-dashboard"
        >
          <LayoutDashboard className="w-5 h-5" />
          <span className="font-body text-sm uppercase tracking-wide">Dashboard</span>
        </NavLink>
        <NavLink
          to="/inventory"
          className={({ isActive }) => 
            `sidebar-link ${isActive ? 'active' : ''}`
          }
          data-testid="nav-inventory"
        >
          <Package className="w-5 h-5" />
          <span className="font-body text-sm uppercase tracking-wide">Inventory</span>
        </NavLink>
      </nav>

      {/* User & Logout */}
      <div className="p-4 border-t border-[#1E293B]">
        <div className="mb-3 px-2">
          <p className="text-white font-body text-sm">{user?.name}</p>
          <p className="text-slate-400 text-xs truncate">{user?.email}</p>
        </div>
        <button
          onClick={handleLogout}
          className="sidebar-link w-full justify-start text-red-400 hover:text-red-300 hover:bg-red-900/20"
          data-testid="logout-btn"
        >
          <LogOut className="w-5 h-5" />
          <span className="font-body text-sm uppercase tracking-wide">Logout</span>
        </button>
      </div>
    </aside>
  );
};
